import {
  Box,
  Separator,
  ToastProvider,
  TooltipProvider,
} from "@prismicio/editor-ui"

import {
  APIExplorerProvider,
  type APIExplorerProviderProps,
} from "./components/APIExplorerContext"
import { APIExplorerRequest } from "./components/APIExplorerRequest"
import { APIExplorerResponse } from "./components/APIExplorerResponse"

type APIExplorerProps = Pick<APIExplorerProviderProps, "repository" | "track">

export function APIExplorer(props: APIExplorerProps) {
  const { repository, track } = props

  return (
    <ToastProvider>
      <TooltipProvider>
        <APIExplorerProvider repository={repository} track={track}>
          <Box
            display="grid"
            gridTemplateColumns="380px 1px minmax(0, 1fr)"
            width="100%"
            height="100%"
            gap={16}
          >
            <APIExplorerRequest />
            <Separator orientation="vertical" style="dashed" decorative />
            <APIExplorerResponse />
          </Box>
        </APIExplorerProvider>
      </TooltipProvider>
    </ToastProvider>
  )
}
